import React from "react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import CheckPermission from "../../../hooks/CheckPermission";
import { TbCheckupList } from "react-icons/tb";
import { FaCalendarAlt } from "react-icons/fa";

const EmptyVisitCard = ({
  data,
  filtersPayload,
  practitionerDepartmentList,
  visit_category,
  payment_status = "Paid",
  order,
  orderData,
  getOrdersPayload,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isPrevDate = moment(filtersPayload?.start_date).isBefore(
    moment(),
    "day"
  );
  const { hasPermission } = CheckPermission();
  const endDateTimeStr =
    moment(filtersPayload?.start_date).format("YYYY-MM-DD") +
    " " +
    data?.end_time;
  const endTime = moment(endDateTimeStr, "YYYY-MM-DD HH:mm");
  const currentTime = moment();

  const selectedPractitioner = practitionerDepartmentList
    ?.flatMap((dept) => dept.practitioners)
    ?.find((p) => p.practitioner_id === filtersPayload?.practitioner_id);

  const handleNavigateCreateAppointment = () => {
    navigate("/create-appointment-from-visit", {
      state: {
        order,
        orderData,
        slot_time: data?.time,
        selectedDate: filtersPayload?.start_date,
        practitionerData: selectedPractitioner,
        getVisitPayload: filtersPayload,
      },
    });
  };

  const handleNavigateCreateVisit = () => {
    let date = moment(filtersPayload?.start_date).format("YYYY-MM-DD");
    let start_time = data?.time;
    let end_time = data?.end_time;
    let day = moment(filtersPayload?.start_date).format("dddd");
    let selectedPractitionerId = filtersPayload?.practitioner_id;
    if (order) {
      navigate("/create-special-visit", {
        state: {
          orderData: orderData,
          getOrdersPayload: getOrdersPayload,
          start_time,
          day,
          date,
          end_time,
        },
      });
    } else {
      navigate("/create-visit", {
        state: {
          start_time,
          day,
          date,
          end_time,
          selectedPractitionerId,
          tab: visit_category == "out_patient" ? "outpatient" : "inpatient",
          payment_status: payment_status == "Paid" ? "paid" : "unpaid",
        },
      });
    }
  };

  return (
    <div className="flex flex-col w-full gap-5 items-center justify-center min-h-[100px] overflow-x-auto relative scrollbar">
      {!isPrevDate && !data?.visit && !data?.appointment ? (
        <div className="absolute top-[10px] right-[5px] flex items-center gap-2">
          <div></div>
          {
            hasPermission("visit", "create") && (
              <div
                className="icon-bg-container"
                onClick={handleNavigateCreateVisit}
              >
                <TbCheckupList
                  size={22}
                  className="text-iconC cursor-pointer"
                  title={order ? "Create Special Visit" : "Create Visit"}
                />
              </div>
            )
            // )
          }
          {hasPermission("appointments", "create") &&
            endTime.isAfter(currentTime, "minute") && (
              <div className="icon-bg-container">
                <FaCalendarAlt
                  size={18}
                  onClick={handleNavigateCreateAppointment}
                  className="text-iconD cursor-pointer"
                  title="Create Appointment"
                />
              </div>
            )}
        </div>
      ) : !data?.visit && !data?.appointment ? (
        <div className="absolute top-[10px] right-[5px] flex items-center gap-2">
          <div></div>
          {
            hasPermission("visit", "create") && (
              // endTime.isAfter(currentTime, "minute") && (
              <div
                className="icon-bg-container"
                onClick={handleNavigateCreateVisit}
              >
                <TbCheckupList
                  size={22}
                  className="text-iconC cursor-pointer"
                  title="Create Visit"
                />
              </div>
            )
            // )
          }
          {hasPermission("appointments", "create") &&
            endTime.isAfter(currentTime, "minute") && (
              <div className="icon-bg-container">
                <FaCalendarAlt
                  size={18}
                  onClick={handleNavigateCreateAppointment}
                  className="text-iconD cursor-pointer"
                  title="Create Appointment"
                />
              </div>
            )}
        </div>
      ) : (
        ""
      )}

    </div>
  );
};

export default EmptyVisitCard;
